import { createRender } from './types';

export const render = createRender(() => <button>{`Hello world!`}</button>);

export default render;
